/**
 * @module store/emails/mutations
 *
 * @version 1.0.2
 * @copyright SBC 2019
 */


import * as types from '@/store/mutation-types';

/* eslint-disable no-param-reassign */
export default {
  /**
   * Mutation: Начало загрузки организаторов стартов
   *
   * @since Version 1.0.2
   */
  [types.GET_STARTS_ORGANIZERS_ASYNC.PENDING](state) {
    state.isLoadingStartsOrganizers = true;
  },


  /**
   * Mutation: Ошибка при загрузке ордеров
   *
   * @since Version 1.0.2
   */
  [types.GET_STARTS_ORGANIZERS_ASYNC.FAILURE](state) {
    state.isLoadingStartsOrganizers = false;
  },


  /**
   * Mutation: Успешная загрузка ордеров
   *
   * @since Version 1.0.2
   */
  [types.GET_STARTS_ORGANIZERS_ASYNC.SUCCESS](state, { data, total }) {
    state.startsOrganizers = data;
    state.totalNumberOfStartsOrganizers = total;
    state.isLoadingStartsOrganizers = false;
  },


  /**
   * Mutation: Успешная загрузка системного организатора стартов
   *
   * @since Version 1.0.0
   */
  [types.GET_SYSTEM_START_ORGANIZER_ASYNC.SUCCESS](state, organizer) {
    state.systemOrganizer = organizer;
  },
};
/* eslint-enable no-param-reassign */
